export const LRW_SESSION_DATE_AVAILABILITIES_TAG = 'LrwSessionDateAvailabilities';
export const ALLOWED_ACTIONS_QUERY_TAG = 'AllowedActions';

export const LRW_SESSION_DETAILS_QUERY_TAG = 'LrwSessionDetails';
export const LRW_SESSION_EDIT_DATA_QUERY_TAG = 'LrwSessionEditData';
export const LRW_SESSION_ALLOWED_ACTIONS_QUERY_TAG = 'LrwSessionAllowedActions';
export const LRW_ASSIGNED_ROOMS_QUERY_TAG = 'LrwSessionAssignedRoomsList';
export const LRW_SESSION_EXAM_OVERVIEW_QUERY_TAG = 'LrwSessionExamOverview';
export const LRW_AVAILABLE_ROOMS_QUERY_TAG = 'LrwSessionAvailableRoomsList';
export const LINKED_SPEAKING_SESSIONS_LIST_QUERY_TAG = 'LinkedSpeakingSessionsList';

export const SPEAKING_SESSION_DETAILS_QUERY_TAG = 'SpeakingSessionDetails';
export const SPEAKING_SESSION_ROOMS_LIST_QUERY_TAG = 'SpeakingSessionRoomsList';
export const SPEAKING_SESSION_ROOMS_EVENTS_LIST_QUERY_TAG = 'SpeakingSessionRoomsEventsList';
export const SPEAKING_SESSION_ALLOWED_ACTIONS_QUERY_TAG = 'SpeakingSessionAllowedActions';

export const TEST_CENTRE_OVERVIEW_QUERY_TAG = 'TestCentreOverview';
